import React from 'react'
import styles from './index.module.less'
import c from 'classnames'

interface Iprops {
  header?: React.ReactNode
  children: React.ReactNode
  prefixCls?: string
  className?: string
}

const ContentBox = (props: Iprops) => {
  const { header, children, className } = props
  const classes = c([styles.box], className)
  return (
    <div className={classes}>
      {header && <div className={styles.header}>{header}</div>}
      {children}
    </div>
  )
}

export default ContentBox
